import api from "../../infra/api";

class ServOcupanteDocs {
    async listar (codigoOcupante) {
        const response = await api({
            method: "GET",
            url: `/api/v1/OcupanteDocs?page=1&start=0&limit=999&fields=["NomeArquivo","Ocupante.Nome","CodigoDocumento1","CodigoDocs","CodigoDocumento2","Id","CodigoOcupante","CodigoConfiguracaoDoc","CodigoClassificacaoDoc"]&sort=[{"property":"CodigoDocs","direction":"DESC"}]&filter=[{"property":"CodigoOcupante","value":"${codigoOcupante}","and":false}]`
        });

        return response.data;
    }

    async AdicionarAnexoNoOcupante(form) {
        const response = await api ({
            method: "POST",
            url: "/api/v1/OcupanteDocs/AdicionarAnexoNoOcupante",
            headers: {
                "Content-Type": "multipart/form-data",
            },
            data: form
        });

        return response.data;
    }

    async AdicionarAnexoNoOcupanteViaAnalista(form) {
        const response = await api ({
            method: "POST",
            url: "/api/v1/OcupanteDocs/AdicionarAnexoNoOcupanteViaAnalista",
            headers: {
                "Content-Type": "multipart/form-data",
            },
            data: form
        });

        return response.data;
    }

    async RealizarDownloadDocumento (codigoOcupanteDoc, codigoDocumento) {
        const response = await api({
            method: "POST",
            url: "api/v1/OcupanteDocs/RealizarDownloadDocumento",
            data: {
                CodigoOcupanteDoc: codigoOcupanteDoc,
                CodigoDocumento: codigoDocumento
            }
        });

        return response.data;
    }

    async RemoverAnexoOcupanteDocs (codigoOcupanteDoc) {
        const response = await api({
            method: "DELETE",
            url: `api/v1/OcupanteDocs/RemoverAnexoOcupanteDocs/${codigoOcupanteDoc}`,
            headers: {
                "Content-Type": "application/json",
            }
        });

        return response.data;
    }
}

export default new ServOcupanteDocs();